export default (string, maxAmount) =>
  string.length <= maxAmount ? string : `${string.slice(0, maxAmount)}...`;
